import router from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import { Color } from "../../theme/Color";
import Button from "../Button/Button";
import FeatureRow from "../FeatureRow";
import PageSection, { StyledSectionHeading } from "../PageSection";
import Spacer from "../Spacer";

const PersonalAppFeatures = () => {
  return (
    <PageSection backgroundColor={Color.White} id="personal-app-features">
      <StyledSectionHeading center="xs">
        Why People Join Valmeego
      </StyledSectionHeading>
      <Row>
        <Col xs={12} sm={10} smOffset={1} md={6} mdOffset={3} lg={false}>
          <Row center="xs">
            <Spacer all={2}>
              <img
                src={`/img/app-screenshots/ireland-map.png`}
                alt="Valmeego.com - Locally and beyond"
                width={338}
                height={680}
              />
            </Spacer>
          </Row>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <FeatureRow title="A place for People, Culture, History & Heritage:">
            <p>
              Valmeego provides members with local content and knowledge
              specifically related to the tourism, history, heritage and
              cultural life of Ireland. Members receive inspiration from fellow
              travellers and local advisors to help them create their own
              personalised experience of Ireland. Members immerse themselves in
              the real Ireland and have a positive impact on the local
              communities they visit.
            </p>
          </FeatureRow>
          <FeatureRow title="Immerse yourself, Don't just Race Around:">
            <p>
              Ireland is a place to truly immerse yourself, yet many visitors
              rush from one spot to the next, missing the magic. Our community
              helps you slow down and explore differently. Real people
              connecting with each other. Real places without the crowds. Real
              stories rooted in our culture. Real impact for people who value
              meaningful travel. You’ll want to come back!
            </p>
          </FeatureRow>
          <FeatureRow title="Make Friends:">
            <p>
              Valmeego’s name comes from combining <i>value</i> and{" "}
              <i>friend</i>. This idea runs through the platform. We believe
              there is a different way to experience Ireland, one that
              encourages people to slow down, travel with local insight, and
              spend time in local communities. Go beyond the cities, visit
              places off the tourist trail, enjoy music played for the locals,
              listen to stories that are less well known, and most importantly,
              make friends along the way.
            </p>
          </FeatureRow>
          <FeatureRow title="Share & Receive Personalised Recommendations:">
            <p>
              Spread good news. Share your favourite spots and hidden gems with
              other members on Valmeego. Reward your positive experiences by
              recommending activities, events and businesses to your inner
              circle and the wider Valmeego community.
            </p>
          </FeatureRow>
        </Col>
        <Col xs={false} lg={4}>
          <Row center="xs">
            <Spacer all={2}>
              <img
                src={`/img/app-screenshots/ireland-map.png`}
                alt="Valmeego.com - Locally and beyond"
                width={427}
                height={680}
              />
            </Spacer>
          </Row>
          <Row center="xs">
            <Col xs={8}>
              <Row center="xs">
                <Button
                  label="Sign Up"
                  size="large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <FeatureRow title="Ask Local Advisors across Ireland as you plan your trip:">
            <p>
              Connect with a community of supportive, helpful locals from all
              over Ireland. These locals want you to have the best experience of
              the Ireland they know and love. Access insider knowledge and
              personalized recommendations specifically tailored to your
              requirements and interests. Uncover Irelands hidden gems, stories
              and people and truly immerse yourself in a different experience.{" "}
            </p>
          </FeatureRow>
          <FeatureRow title="Explore Ireland Before you arrive:">
            <p>
              Browse content feeds across Ireland, making it easy to see what
              each county, city, and town has to offer at any given time. Local
              advisors, businesses, and fellow travellers share local knowledge,
              stories, events, and places worth knowing about. Travel with
              confidence and experience Ireland in a deeper, more meaningful
              way.
            </p>
          </FeatureRow>
          <FeatureRow title="A comprehensive FREE trip planning tool:">
            <p>
              Keep all your trips in one place. Create and manage all your trips
              in a single platfrom. Effortlessly plan, coordinate and manage all
              aspects of each trip from short breaks to extended journeys.
              Invite friends, chat as a group, manage group payments,
              personalise itineraries, store essential documents, set reminders,
              and ask local advisors for their input as you plan.
            </p>
          </FeatureRow>
          <FeatureRow title="Book Directly for a Better Experience:">
            <p>
              Valmeego is a direct booking platform, connecting members directly
              with recommended local businesses throughout Ireland. Members are
              valued and receive personalised customer service directly from the
              provider.
            </p>
          </FeatureRow>
        </Col>
        <Col xs={12} md={false}>
          <Spacer bottom={6}>
            <Row center="xs">
              <Col xs={8}>
                <Button
                  label="Sign up"
                  size="large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
              </Col>
            </Row>
          </Spacer>
        </Col>
      </Row>
    </PageSection>
  );
};

export default PersonalAppFeatures;
